/**
 * S05 — ACT III: THE BUSINESS MAN (The White Truffle Wars)
 *
 * Full-bleed HF#7 Colombian cartel negotiation as a looping MP4
 * sequence — drone overhead of Meyhem mid-negotiation in a coffee
 * plantation. The HF#7 poster still serves as the loading fallback
 * so there's no flash of black before the video boots. Gold overlay
 * wash. Uses the shared ActSection primitive (handles autoplay,
 * mobile playsinline, IntersectionObserver pause/play).
 */

import { ActSection } from "./ActSection";
import { sectionCopy, actStories } from "@/lib/voice";
import videoSrc from "@/assets/higgsfield/hf-07-act-iii-sequence.mp4";
import posterSrc from "@/assets/higgsfield/hf-07-act-iii-sequence-poster.webp";

export function S05_ActThree() {
  const copy = sectionCopy.s05;
  return (
    <ActSection
      sectionId="s05"
      meta={copy.meta}
      monument={copy.monument}
      act={actStories.act3}
      videoSrc={videoSrc}
      videoPoster={posterSrc}
      spotColor="gold"
      bgFilter="contrast(1.12) brightness(0.5) saturate(0.85)"
      overlayGradient="radial-gradient(ellipse at center, rgba(5,5,5,0.35) 0%, rgba(5,5,5,0.9) 100%)"
    />
  );
}
